import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { GetByQuotationlist ,quotationDelete } from '../store/slices/sale';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import {API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import { FaFilePdf } from "react-icons/fa6";
import { FaFileExcel } from "react-icons/fa";
import {toast } from 'react-hot-toast';
import {excelQuotationDownload } from "../common/ExcelDownload"

const QuotationList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [invoicelist, setInvoicelist] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);
  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Quotation Number',field: 'quotation_combined'},
    {header: 'Date', field: 'quotation_date' },
    { header: 'Party', field: 'party_name' },
    { header: 'State', field: 'billing_state' },
    { header: 'Amount', field: 'grand_total' },
    { header: 'Payment Status', field: '' },
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'Edit', className: 'btn-default' }, 
        { name: 'Delete', className: 'btn-cancel' },
           { 
                  className: 'btn-danger' ,
                  icon: <FaFilePdf style={{ fontSize: "15px",}} />,
          }, 
      ]
    }
  ]);

  
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    navigate(`/quotation/edit/${item.id ? item.id : null}`)
  };


  const handleDelete = (item) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this Quotation?");
    if (confirmDelete) {
          setIsLoading(true);
           dispatch(quotationDelete({ id: item.id, profile_id: id  }))
          .unwrap()
          .then((data) => {
              setIsLoading(false);
              hindleReturn();
          })
          .catch(({ message }) => {
            setIsLoading(false);
            toast.error(message);
          });
    } else {
      console.log("Deletion canceled");
    }
  };


  const hindleReturn = () => {
    setIsLoading(true);
    dispatch(GetByQuotationlist({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setInvoicelist(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  };


  React.useEffect(() => {
    setIsLoading(true);
    dispatch(GetByQuotationlist({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setInvoicelist(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  }, [dispatch]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filtereditemList = invoicelist?.filter(party => 
    party?.invoice_number?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.invoice_date?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.billing_state?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.party_name?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.grand_total?.toLowerCase()?.includes(searchQuery?.toLowerCase())

  );

  const handlePDF = (item) => {
    const data=`${API_BASE_URL}${API_PATHS.quotationpdf}/${item?.id}`
      navigate('/Pdf-Viewer', { state: { data } });
  };

    const handleExcelDownload = () => {
      if (!invoicelist || invoicelist.length === 0) {
          alert("No data available for download.");
          return;
      }
  
      const selectedInvoices = selectAll && invoicelist.length > 0
          ? invoicelist.map(invoice => invoice.id)
          : selectedRows;
  
      if (!selectedInvoices || selectedInvoices.length === 0) {
          alert("Please select at least one Quotation.");
          return;
      }
  
      const selectedData = invoicelist.filter(invoice => selectedInvoices.includes(invoice.id));
  
      if (selectedData.length === 0) {
          alert("No matching Quotation found.");
          return;
      }
  
      try {
        excelQuotationDownload(selectedData, "Quotation.xlsx");
          toast.success("Downloading Excel file successfully!");
      } catch (error) {
          console.error("Error downloading Excel file:", error);
          alert("Failed to download the Excel file. Please try again.");
      }
  };

  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Quotations</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Sale</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Quotation List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                  <button className="btn ripple btn-default" onClick={() => navigate('/quotation/create')}>
                       Add New Quotation
                  </button>
                    <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                   Export Excel <FaFileExcel/>
                                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                 <Table
                    columns={columns}
                    data={filtereditemList}
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filtereditemList?.length}
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handlePDF={handlePDF}
                    handleSearchChange={handleSearchChange}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows} 
                    selectAll={selectAll} 
                     setSelectAll={setSelectAll} 
                  />
                </div>
              </div>
            </div>
          </div>
        </AdminLayout>
  );
};

export default QuotationList;
